import React, { useRef } from "react";
import MainTable from "../../Components/Tables/Main/MainTable";
import { useVehicleDocuments } from "../../Hooks/useVehicleDocuments";
import { useVehicles } from "../../Hooks/useVehicles";
// Libraries
import { useParams } from "react-router-dom";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { saveAs } from "file-saver";
import { resolveTimezoneOffsetError } from "../../CommonConstants";
const noVisibleInputStyle = { display: "none" };

const VehicleDocuments = () => {
  let { vehicleId } = useParams();
  vehicleId = +vehicleId;
  const [
    documentsData,
    addDocument,
    getVehicleDocumentFile,
    updateVehicleDocument,
    deleteVehicleDocument,
  ] = useVehicleDocuments(vehicleId);
  const [vehiclesData] = useVehicles();
  const fileInput = useRef(null);

  const handleClick = () => fileInput.current.click();

  const vehicle = vehiclesData.find(({ id }) => id === vehicleId);
  let vehicleName = "";
  if (vehicle) {
    const { brand, model, patent } = vehicle;
    vehicleName = `${brand} ${model} ${patent}`;
  }

  const columns = [
    { title: "Id", field: "id", hidden: true },
    { title: "Nombre", field: "name" },
    {
      title: "Fecha de expiración", field: "expirationDate", type: "date",
      render: row => row.expirationDate ? <span>{resolveTimezoneOffsetError(row.expirationDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}
          locale={props.dateTimePickerLocalization}>
          <DatePicker
            format="dd/MM/yyyy"
            value={props.value ? resolveTimezoneOffsetError(props.value) : null}
            onChange={props.onChange}
            clearable
            InputProps={{
              style: {
                fontSize: 13,
              }
            }}
          />
        </MuiPickersUtilsProvider>
      )
    },
    { title: "fileId", field: "fileId", hidden: true },
    {
      title: "Archivo",
      field: "file",
      editComponent: (props) => {
        const doc = props.rowData.doc || { name: "" };
        return (
          <div>
            <button onClick={handleClick}>
              {doc ? "Archivo seleccionado" : "Seleccione un archivo"}
            </button>
            <div>{` ${doc.name}`}</div>
            <input
              type="file"
              ref={fileInput}
              style={noVisibleInputStyle}
              onChange={(e) => {
                if (e.target && e.target.files.length) {
                  const data = { ...props.rowData };
                  data.doc = e.target.files[0];
                  props.onRowDataChange(data);
                }
              }}
            />
          </div>
        );
      },
      render: () => "",
    },
  ];

  const isDocumentPDF = (mimeType) => mimeType === 'application/pdf'

  const actions = [
    {
      icon: VisibilityIcon,
      tooltip: "Previsualizar",
      onClick: async (event, document) => {
        const fileResponse = await getVehicleDocumentFile(document.fileId, isDocumentPDF(document.mimeType));
        const contentType = fileResponse.headers["content-type"];
        if (isDocumentPDF(contentType)) {
          const blob = new Blob([fileResponse.data], {
            type: contentType,
          });
          window.open(URL.createObjectURL(blob));
        } else {
          const img = new Image();
          img.src = `data:${contentType};base64,${fileResponse.data}`;
          const w = window.open("");
          w.document.write(img.outerHTML);
        }
      },
    },
    {
      icon: GetAppIcon,
      tooltip: "Descargar",
      onClick: async (event, document) => {
        const fileResponse = await getVehicleDocumentFile(document.fileId, isDocumentPDF(document.mimeType));
        const contentType = fileResponse.headers["content-type"];
        let downloadItem = null;
        let imageType = "";
        if (isDocumentPDF(contentType)) {
          const blob = new Blob([fileResponse.data], {
            type: contentType,
          });
          downloadItem = blob;
          imageType = "pdf";
        } else {
          downloadItem = dataURItoBlob(
            `data:${contentType};base64,${fileResponse.data}`
          );
          imageType = contentType.split(" ")[0].split("/")[1].slice(0, -1);
        }
        saveAs(downloadItem, `${document.name}.${imageType}`);
      },
    },
  ];

  function dataURItoBlob(dataURI) {
    // Example link: https://gist.github.com/fupslot/5015897#gistcomment-1580216
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);

    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    let bb = new Blob([ab]);
    return bb;
  }

  return (
    <MainTable
      title={`Documentos de ${vehicleName}`}
      columns={columns}
      data={documentsData}
      actions={actions}
      requiredFields={["name"]}
      deleteText="Se borraran todos los documentos asociados"
      onRowAdd={async (newData) => {
        const dataToSave = { ...newData, vehicleId }
        dataToSave.expirationDate = dataToSave.expirationDate ? resolveTimezoneOffsetError(dataToSave.expirationDate, 'yyyy-MM-dd') : ''
        await addDocument(dataToSave);
      }}
      onRowUpdate={async (newData) => {
        const dataToSave = { ...newData }
        dataToSave.expirationDate = dataToSave.expirationDate ? resolveTimezoneOffsetError(dataToSave.expirationDate, 'yyyy-MM-dd') : ''
        await updateVehicleDocument(dataToSave)
      }}
      onRowDelete={deleteVehicleDocument}
    />
  );
};

export default VehicleDocuments;



// WEBPACK FOOTER //
// ./src/Containers/VehicleDocuments/index.js